import React from 'react';
import Button from '../../buttons/Button';

/**
 * Handles displaying the login button
 * @returns
 */
function LoginBtn() {
	return <Button htmlFor="login-modal" icon="login" color="btn-primary" text="login" />;
}

export default LoginBtn;
